
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"#6C7684","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.025 3.953a8.072 8.072 0 110 16.144 8.072 8.072 0 010-16.144zm0-2.953a11.025 11.025 0 1011.024 11.025A11.006 11.006 0 0012.025 1z"}}),_c('path',{attrs:{"d":"M13.55 5.479h-2.953v8.17h2.953v-8.17z"}})])
          )
        }
      }
    